import { useEffect } from "react";

import { type RouteAppComponentProps } from "@/router/routes";
import { setPageTitle } from "@/utils/hook";

import { AppAccessNotConfiguredView } from "./view";

function _AppAccessNotConfigured(props: RouteAppComponentProps) {
  useEffect(() => {
    setPageTitle(window)(props.pageName)();
  }, [props.pageName]);

  return <AppAccessNotConfiguredView />;
}

const AppAccessNotConfigured = _AppAccessNotConfigured;

export default AppAccessNotConfigured;
